import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import { useNavigate } from "react-router-dom";
import { Container, Grid } from "@mui/material";
import CustomTextField from "../../components/CustomTextField";
import { ReactComponent as ArrowLeftSvg } from "../../../src/assets/svg/arrow-left.svg";
import logo from "../../assets/safe_truck_small_logo.png";
import { useTranslation } from "react-i18next";

const AddOperatorAddress = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const renderOperatorAddressForm = (
    <>
      <Stack spacing={2}>
        <Grid container sx={{ mb: 3 }} direction={"row"}>
          <ArrowLeftSvg
            style={{ alignSelf: "center" }}
            onClick={() => {
              navigate(-1);
            }}
          />
          <Typography sx={{ ml: 1 }} variant="h5">
            {t("pages.operatorAddressDetails.pageHeading")}
          </Typography>
        </Grid>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        ></Box>
        <CustomTextField
          label={t("pages.operatorAddressDetails.text01")}
          required
        />
        <CustomTextField
          label={t("pages.operatorAddressDetails.text03")}
          required
        />
        <CustomTextField
          label={t("pages.operatorAddressDetails.text04")}
          required
        />
        <CustomTextField
          label={t("pages.operatorAddressDetails.text02")}
          required
        />
      </Stack>
    </>
  );

  return (
    <Container
      style={{
        padding: 0,
        position: "relative",
        minHeight: "100vh",
        backgroundColor: "#80BCFF4F",
      }}
    >
      <Box>
        <img
          src={logo}
          alt="Your Alt Text"
          style={{
            width: "20%",
            marginTop: "10%",
            height: "auto",
            marginLeft: "20px",
          }}
        />
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{ height: 1, padding: 0 }}
        >
          <Card
            sx={{
              p: 3,
              width: 1,
              maxWidth: 430,
              overflow: "auto",
              minHeight: "60vh",
            }}
            style={{
              position: "absolute",
              top: "10%",
              bottom: 0,
            }}
          >
            {renderOperatorAddressForm}
            <LoadingButton
              sx={{ mt: 5, mb: 5, width: 327, alignSelf: "center" }}
              size="large"
              type="submit"
              variant="contained"
              color="inherit"
              onClick={() => {
                navigate("/inviteDrivers");
              }}
            >
              {t("commonLables.text01")}
            </LoadingButton>
          </Card>
        </Stack>
      </Box>
    </Container>
  );
};

export default AddOperatorAddress;
